import jwtDecode from 'jwt-decode';

const pgOriginalInstanceIds = [
  '42a8caa2-d489-4fdf-acc5-45d2391c1c8b',
  '7ae3658d-046c-48c0-b405-b43ef41b8c3e',
  'ab1b11bf-1fd1-4ecf-8efa-15f7926c1673',
  '317544fa-570b-45d9-ba0e-13b01bd3e190',
  '75bcd25e-d28e-4b54-b6f8-6c42acea088c',
  '5d8dfae5-5823-428c-a1ad-f84eee069fb8',
];

export const isInAlbums = ({ instance }) => {
  try {
    const { originInstanceId } = jwtDecode(instance);

    return pgOriginalInstanceIds.indexOf(originInstanceId) > -1;
  } catch (e) {
    return false;
  }
};

export const shouldFillAlbumItemsFromServer = (
  totalItemsCount,
  albumData,
  galleryId,
) => {
  return (
    (albumData &&
      (totalItemsCount > 50 || albumData.version === 3) &&
      albumData.defaultSetId) ||
    galleryId
  );
};
